import type { NavItem } from '../../../../_metronic/helpers/utils/types';

export const resourceData: NavItem[] = [
  {
    label: 'Intro',
    to: '/pages/resource/intro'
  },
  {
    label: 'Programs',
    to: '/pages/resource/program'
  },
  {
    label: 'Tools',
    to: '/pages/resource/tools'
  },
  {
    label: 'Stats',
    to: '/pages/resource/stats'
  }
];
